module.exports = new __parcel__URL__("envelope.218572ce.svg").toString();